//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export const PROMOTED_POSTS_TARGET_ACTIONS = {
  CLEAR_PROMOTED_POSTS_TARGET_STATE: 'CLEAR_PROMOTED_POSTS_TARGET_STATE',
  UPDATE_SELECTED_TARGET: 'UPDATE_SELECTED_TARGET',
  UPDATE_TARGET_LINK: 'UPDATE_TARGET_LINK',
  UPDATE_CUSTOM_LINK: 'UPDATE_CUSTOM_LINK',
  UPDATE_TARGET_LINK_CTA: 'UPDATE_TARGET_LINK_CTA',
  REQUEST_PRODUCT_COUNT: 'REQUEST_PRODUCT_COUNT',
  RECEIVE_PRODUCT_COUNT: 'RECEIVE_PRODUCT_COUNT',
  REQUEST_SHOWROOM_FOR_POST: 'REQUEST_SHOWROOM_FOR_POST',
  RECEIVE_SHOWROOM_FOR_POST: 'RECEIVE_SHOWROOM_FOR_POST',
};

export enum PromotedPostsTargetCTAs {
    SHOP_NOW = 'SHOP_NOW',
    LEARN_MORE = 'LEARN_MORE',
    BOOK_TRAVEL = 'BOOK_TRAVEL',
    WATCH_MORE = 'WATCH_MORE',
    SIGN_UP = 'SIGN_UP',
}

export const PromotedPostsTargetCTAOptions = [
    { value: PromotedPostsTargetCTAs.SHOP_NOW, label: 'Shop Now' },
    { value: PromotedPostsTargetCTAs.LEARN_MORE, label: 'Learn More' },
    { value: PromotedPostsTargetCTAs.BOOK_TRAVEL, label: 'Book Now' },
    { value: PromotedPostsTargetCTAs.WATCH_MORE, label: 'Watch More' },
    { value: PromotedPostsTargetCTAs.SIGN_UP, label: 'Sign Up' },
];

export enum PromotedPostsTargetOptions {
    SHOWROOM_LINK = 'showroom',
    CUSTOM_LINK = 'custom',
}
